module.exports = __webpack_public_path__ + "static/media/calendar.1e889332.svg";